import { useMutation } from '@tanstack/react-query';
import LangEnum from '../../../lang/LangEnum';
import {
  exportOrderHistoricStatusCsv,
  exportOrderIntegrationCsv,
} from '../../../modules/orders/repositories/orderActions.repository';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import snackbarStore from '../../../stores/Snackbar.store';
import { ActivityFeedSnapshotKind, DownloadActivityFeedSnapshotParams } from './activityFeed.types';

const EXPORT_CSV_BY_SNAPSHOT_KIND: Record<
  ActivityFeedSnapshotKind,
  typeof exportOrderHistoricStatusCsv
> = {
  'order-history': exportOrderHistoricStatusCsv,
  'order-integration-result': exportOrderIntegrationCsv,
};

export const useDownloadActivityFeedSnapshotMutation = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const { isPending, mutate: downloadSnapshot } = useMutation({
    mutationFn: async ({ eventId, snapshotKind, filename }: DownloadActivityFeedSnapshotParams) => {
      const response = await EXPORT_CSV_BY_SNAPSHOT_KIND[snapshotKind]({ eventId, filename });

      if (!response.ok || !response.data) {
        throw new Error(`failed to download the ${snapshotKind} snapshot of the event ${eventId}`);
      }
    },
    onError: () => {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.SNACKBAR_ERROR_DOWNLOADING_CSV),
      });
    },
  });

  return { isPending, downloadSnapshot };
};
